import { Box, Flex, Text } from "@radix-ui/themes";
import { CartItem } from "@/features/annotation/lib/types";
import { OrderLine } from "@/shared/api/lod-api";
import ProductItem from "./product-item";
import CartIsEmpty from "./cart-is-empty";

interface CartColumnProps {
  item?: CartItem | OrderLine;
  isCartEmpty: boolean;
  isFirstRow: boolean;
  isQuantityDifferent: boolean;
  type: "annotated" | "order";
}

export const CartColumn = ({
  item,
  isCartEmpty,
  isFirstRow,
  isQuantityDifferent,
  type,
}: CartColumnProps) => {
  if (item) {
    const productProps =
      type === "annotated"
        ? {
            name: (item as CartItem).name,
            imageUrl: (item as CartItem).imageUrl,
            barcode: (item as CartItem).barcode,
            skuId: (item as CartItem).skuId,
            quantity: (item as CartItem).quantity,
            unitOfMeasurement: (item as CartItem).uom,
          }
        : {
            name: (item as OrderLine).name,
            imageUrl: (item as OrderLine).image_url,
            barcode: (item as OrderLine).barcode,
            skuId: (item as OrderLine).sku_base_id,
            quantity: (item as OrderLine).quantity,
            unitOfMeasurement: (item as OrderLine).uom,
          };

    return (
      <Box className="mx-3">
        <ProductItem
          {...productProps}
          isQuantityNegative={productProps.quantity < 0}
          isQuantityDifferent={isQuantityDifferent}
        />
      </Box>
    );
  }

  if (!isCartEmpty) {
    return (
      <Flex justify="center" align="center" className="h-20 mx-3">
        <Text size="1" color="gray">
          No matching data
        </Text>
      </Flex>
    );
  }

  if (isFirstRow) {
    return (
      <Box className="mx-3">
        <CartIsEmpty />
      </Box>
    );
  }

  return null;
};
